import {
  Autocomplete,
  Box,
  Button,
  Card,
  Grid,
  InputLabel,
  TextField,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  InputAdornment,
} from "@mui/material";
import RightViewLayout from "../../components/RighViewLayout";
import CustomInput from "../../components/CustomInput";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { REACT_PRODUCT } from "../../router/ReactEndPoints";
import React, { useState } from "react";
import { uploadFile } from "@/services/Upload";

import {
  attributeList,
  downloadImage,
  findProductById,
  updateProduct,
  getEventInfo,
  UpdataPriceEvent,
  getCurrentData,
} from "../../services/ProductService";
import { useEffect } from "react";
import CommonUtil from "../../util/CommonUtils";
import Image from "../../assets/images/ProfilePic.svg";
import axios from "axios";
import { handlerPriceData, handlerUpdataFile } from "./interfece";
import DropzoneComponent from "../../components/layout-components/DropzoneComponent";
import { ReactComponent as Upload_Image } from "../../assets/images/Upload_Image.svg";

export default function EditProduct() {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  let location = useLocation();
  const [product, setProduct] = useState({});

  const [customePayload, setCustomePayload] = useState({});
  const [image, setImage] = useState(null);
  const [productImage, setProductImage] = useState();
  const [objectKey, setObjectKey] = useState();
  const [newLabels, setNewLabels] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [priceEventList, setPriceEventList] = useState([]); // 变价事件列表
  const [templateList, setTemplateList] = useState([]); //模板事件列表

  const [confirm, setConfirm] = useState(false);

  const [payload, setPayload] = useState({
    id: location.state?.id,
    productImage: "",
  });

  const [productPhoto, setProductPhoto] = useState(null);

  useEffect(() => {
    findProductById(location.state?.id).then((res) => {
      if (res?.data?.data && res?.data?.code === "LVLI0000") {
        setProduct(res.data.data);
        setProductPhoto(res.data.data?.product?.productImage)

        setPayload({
          ...payload,
          productImage: res.data.data?.product?.productImage,
        });

        setObjectKey(res.data.data.product.objectKey);
        setCustomePayload(res.data.data.object);
      }
    });
  }, []);

  useEffect(() => {
    if (objectKey) {
      downloadImage(objectKey).then((res) => {
        if (res?.data?.data && res?.data?.code === "LVLI0000") {
          setImage(res?.data?.data?.url);
        }
      });
    }
  }, [objectKey]);

  useEffect(() => {
    attributeList().then((res) => {
      if (res?.data?.code == "LVLI0000") {
        let list = res?.data?.data?.filter((item) => {
          return !(
            item.dataLevel === "System Default" && item.name === "priceRule"
          );
        });

        setNewLabels(list?.filter(item => item.type === "1" || item.type == null || item.type === "" || item.type === undefined));
        setFileList(list?.filter((item) => item.type == "2"))
      }
    });
  }, []);

  const handleCustomChange = (name, value) => {
    setCustomePayload((prevPayload) => ({
      ...prevPayload,
      [name]: value,
    }));
  };


  const [imageMap, setImageMap] = useState({});

  const handleImage = (name, file) => {
    const maxSize = 3 * 1024 * 1024; // 3MB in bytes
    if (
      file.file.type === "image/png" ||
      file.file.type === "image/jpeg" ||
      file.file.type === "image/bmp"
    ) {
      let fileSize = file.file.size;
      let size = parseInt(fileSize);
      if (size <= maxSize) {
        uploadFile(file).then((res) => {
          if (name == "productImage") {
            setPayload((prevPayload) => {
              const newPayload = { ...prevPayload };
              newPayload[name] = res?.data?.data;
              return newPayload;
            });
            setProductPhoto(file?.base64)
          } else {
            setCustomePayload((prevPayload) => {
              const newPayload = { ...prevPayload };
              newPayload[name] = res?.data?.data;
              return newPayload;
            });
          }
        });
        setImageMap((prev) => ({ ...prev, [name]: file?.base64 }));

      } else {
        enqueueSnackbar(t("tips_product.file_size_limit"), {
          variant: "error",
        });
      }
    } else {

      enqueueSnackbar(t("EPLPR0304"), {
        variant: "error",
      });
    }
  };

  const uploadProductPhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data?.data?.data?.preSignedUrl);
    bodyFormData.append("file", productImage);

    axios({
      method: "post",
      url: process.env.REACT_APP_SERVER_URL + "/web/product/image",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("USER_TOKEN"),
      },
    }).then(() => {
      enqueueSnackbar(t("tips_product.product_updated_success"), {
        variant: "success",
      });
      navigate(REACT_PRODUCT);
    });
  };

  const handleSubmit = async (id) => {
    let request = {
      product: payload,
      object: customePayload,
    };

    try {
      const response = await updateProduct(request); // 等待 updateProduct 完成

      // 检查响应
      if (response?.data?.code === "LVLI0003") {
        if (
          CommonUtil.isEmpty(response?.data?.data?.preSignedUrl) &&
          !productImage
        ) {
          enqueueSnackbar(t("tips_product.product_updated_success"), {
            variant: "success",
          });
          navigate(REACT_PRODUCT);
        } else {
          uploadProductPhoto(response);
        }
      } else {
        enqueueSnackbar(response?.data?.message, { variant: "error" });
        return; // 终止执行，跳出函数
      }

      // 如果没有返回，继续执行后面的代码
      const getEventRes = await getEventInfo({ productId: location.state.id });

      let res = handlerPriceData(
        getEventRes?.data?.data,
        payload,
        setPriceEventList,
        setTemplateList,
        customePayload
      );

      processPriceList(res.priceList, res?.templateList);
    } catch (error) {
      // 处理可能的错误
      enqueueSnackbar(t("An error occurred while updating the product."), {
        variant: "error",
      });
      console.error(error);
    }
  };
  const processItem = (item, type) => {
    return handlerUpdataFile(item, type);
  };

  const processPriceList = async (priceList, templateList) => {
    try {
      const pricePromises = priceList.map((item) => processItem(item, "0"));

      const templatePromises = templateList.map((item) =>
        processItem(item, "1")
      );

      const [priceResults, templateResults] = await Promise.all([
        Promise.all(pricePromises),
        Promise.all(templatePromises),
      ]);

      const validPriceResults = priceResults.filter((res) => res !== null);

      const validTemplateResults = templateResults.filter(
        (res) => res !== null
      );

      if (validPriceResults.length > 0 || validTemplateResults.length > 0) {
        const params = {
          productId: location.state.id,
          templateImageList: validTemplateResults.map((res) => ({
            templateId: res?.id,
            imageUrl: res?.imageUrl,
          })),
          eventTemplateImageList: validPriceResults.map((res) => ({
            priceChangeEventId: res?.id,
            templateId: res?.templateVO?.id,
            imageUrl: res?.imageUrl,
          })),
        };

        const apiResponse = await UpdataPriceEvent(params);
        if (apiResponse?.data?.code === "LVLI0000") {
          enqueueSnackbar(apiResponse?.data?.message, {
            variant: "success",
          });
        }
      }
    } catch (error) {
      console.error("Error processing price or template list:", error);
    }
  };

  return (
    <RightViewLayout
      title={t("product.edit_product")}
      navigateBack={REACT_PRODUCT}
    >
      <Grid sx={{ height: "100%" }}>
        <Card elevation={0}>
          <Grid container item>
            <Grid container px={2} spacing={2} sx={{ maxHeight: 450, overflowY: "auto" }}>
              <Grid item xs={12} md={4}>
                <Typography
                  style={{
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    fontSize: "12px",
                    color: "rgb(71, 75, 79)",
                  }}
                  color="textSecondary"
                  pt={1}
                >
                  {t("product.product_picture")}
                </Typography>
                <DropzoneComponent
                  getExcelFile={(excelData) => handleImage("productImage", excelData)}>

                  <Box
                    mt={0}
                    p={1}
                    sx={{
                      border: "2px dashed #36C96D",
                      borderRadius: "5px",
                      backgroundColor: "rgba(54, 201, 109,0.1)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      height: "400px",
                    }}
                  >
                    {productPhoto ? (
                      <img
                        src={productPhoto}
                        alt="Uploaded"
                        style={{ maxWidth: "100%", maxHeight: "200px" }}
                      />
                    ) : productPhoto ? (
                      <img
                        src={productPhoto}
                        alt="Uploaded"
                        style={{ maxWidth: "100%", maxHeight: "200px" }}
                      />
                    ) : image ? (
                      <img
                        src={image}
                        alt="Uploaded"
                        style={{ maxWidth: "100%", maxHeight: "200px" }}
                      />
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <Upload_Image width="100px" height="100px" />
                        <Typography
                          sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            opacity: "0.8",
                            mt: 1,
                          }}
                        >
                          {t("tips_product.drag_and_drop_file")}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            opacity: "0.8",
                          }}
                        >
                          {t("tips_product.upload_image_format")}
                        </Typography>
                      </div>
                    )}
                  </Box>
                </DropzoneComponent>
              </Grid>

              <Grid container xs={12} md={8} item spacing={2} mt={2}>
                {newLabels.map((field, index) => {
                  return (
                    <Grid key={index} item md={4} xs={12}>
                      <CustomInput
                        id="AddProduct12"
                        size="small"
                        label={field.label}
                        required={field.name == "productName"}
                        value={customePayload[field.name]}
                        handleChange={(event) =>
                          handleCustomChange(field.name, event.target.value)
                        }
                        inputProps={{
                          maxLength: 50,
                        }}
                        name={field.name}
                        resetError={() => console.log()}
                        fullWidth
                        placeholder={t("common.enter") + field.label}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>


            {/* Additional Images Section */}
            {fileList && fileList.length > 0 && (
              <Grid container px={2} mt={2} spacing={3}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {fileList?.map((item, index) => {
                      return (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                          <Typography
                            style={{
                              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              fontWeight: 400,
                              fontSize: "12px",
                              color: "rgb(71, 75, 79)",
                            }}
                            color="textSecondary"
                            pt={1}>
                            {item?.label}
                          </Typography>
                          <DropzoneComponent
                            getExcelFile={(excelData) => handleImage(item.name, excelData)}>
                            <Box
                              mt={0}
                              p={1}
                              sx={{
                                border: "2px dashed #36C96D",
                                borderRadius: "5px",
                                backgroundColor: "rgba(54, 201, 109,0.1)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                height: "200px",
                              }}>
                              {imageMap[item.name] ? (
                                <img
                                  src={imageMap[item.name]}
                                  alt="Uploaded"
                                  style={{ maxWidth: "100%", maxHeight: "100px" }}
                                />
                              ) : customePayload[item.name] ? (
                                <img
                                  src={customePayload[item.name]}
                                  alt="Uploaded"
                                  style={{ maxWidth: "100%", maxHeight: "100px" }}
                                />
                              ) : (
                                <div style={{ textAlign: "center" }}>
                                  <Upload_Image />
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      textAlign: "center",
                                      opacity: "0.8",
                                      mt: 1,
                                    }}>
                                    {t("tips_product.drag_and_drop_file")}
                                  </Typography>
                                </div>
                              )}
                            </Box>
                          </DropzoneComponent>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
            )}


            <Grid container spacing={2} px={2} py={2}>
              <Grid item xs={12}>
                <Box display={"flex"} flexDirection={"row-reverse"}>
                  <Box item pl={2}>
                    <Button
                      id="EditProduct-button-01"
                      variant="contained"
                      size="large"
                      className="text-transform-none"
                      onClick={() => {
                        setConfirm(true);
                      }}
                      style={{
                        size: "medium",
                        background:
                          "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%) 0% 0% no-repeat padding-box",
                        borderRadius: "8px",
                        opacity: 1,
                      }}
                    >
                      {t("common.save")}
                    </Button>
                  </Box>
                  <Box item>
                    <Button
                      id="EditProduct-button-02"
                      className="text-transform-none"
                      variant="outlined"
                      onClick={() => navigate(REACT_PRODUCT)}
                      size="large"
                    >
                      {t("common.back")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      <DialogAffirm
        confirm={confirm}
        setConfirm={setConfirm}
        handleSubmit={handleSubmit}
      ></DialogAffirm>
    </RightViewLayout>
  );
}

const DialogAffirm = ({ confirm, setConfirm, handleSubmit }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={confirm}
      onClose={() => {
        setConfirm(false);
      }}
      maxWidth="md"
    >
      <DialogTitle>
        <div
          dangerouslySetInnerHTML={{
            __html: t("tips_product.sure_change_product"),
          }}
          style={{ textAlign: "center" }}
        ></div>
      </DialogTitle>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        padding={"10px"}
        justifyContent={"center"}
      >
        <Box display="flex" justifyContent="center">
          <Button
            variant="outlined"
            color="primary"
            style={{
              fontSize: "normal normal normal 14px / 22px Roboto",
              width: "80px",
            }}
            onClick={() => {
              setConfirm(false);
            }}
            sx={{ marginRight: 2 }}
          >
            {t("common.back")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{
              background:
                "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%)",
              color: "#FFFFFF",
              fontSize: "normal normal normal 14px / 22px Roboto",
              width: "80px",
            }}
            onClick={handleSubmit}
          >
            {t("common.save")}
          </Button>
        </Box>
      </Grid>
    </Dialog>
  );
};